var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLink2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 91,
    viewBox: "0 0 88 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8555 23.9928C27.7132 20.792 31.0032 18.8925 34.204 19.7502L70.4639 29.466C73.6647 30.3237 75.5642 33.6137 74.7066 36.8145L64.9908 73.0744C64.1331 76.2752 60.8431 78.1747 57.6423 77.3171L21.3823 67.6012C18.1816 66.7436 16.2821 63.4536 17.1397 60.2528L26.8555 23.9928Z",
    fill: "#F22E62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8555 23.9928C27.7132 20.792 31.0032 18.8925 34.204 19.7502L70.4639 29.466C73.6647 30.3237 75.5642 33.6137 74.7066 36.8145L64.9908 73.0744C64.1331 76.2752 60.8431 78.1747 57.6423 77.3171L21.3823 67.6012C18.1816 66.7436 16.2821 63.4536 17.1397 60.2528L26.8555 23.9928Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.855 20.7272C25.7127 17.5264 29.0027 15.6269 32.2035 16.4846L68.4635 26.2004C71.6643 27.058 73.5637 30.3481 72.7061 33.5488L62.9903 69.8088C62.1326 73.0096 58.8426 74.9091 55.6418 74.0514L19.3819 64.3356C16.1811 63.478 14.2816 60.1879 15.1392 56.9871L24.855 20.7272Z",
    fill: "#F22E62"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8548 17.4616C23.7125 14.2608 27.0025 12.3613 30.2033 13.2189L66.4632 22.9348C69.664 23.7924 71.5635 27.0824 70.7058 30.2832L60.99 66.5432C60.1324 69.744 56.8423 71.6434 53.6416 70.7858L17.3816 61.07C14.1808 60.2123 12.2813 56.9223 13.139 53.7215L22.8548 17.4616Z",
    fill: "#F22E62"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8548 17.4616C23.7125 14.2608 27.0025 12.3613 30.2033 13.2189L66.4632 22.9348C69.664 23.7924 71.5635 27.0824 70.7058 30.2832L60.99 66.5432C60.1324 69.744 56.8423 71.6434 53.6416 70.7858L17.3816 61.07C14.1808 60.2123 12.2813 56.9223 13.139 53.7215L22.8548 17.4616Z",
    fill: "#200020",
    fillOpacity: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink2);
export default __webpack_public_path__ + "static/media/link2.cc84f3c020ffe8a09c7b3e4b1e03a95c.svg";
export { ForwardRef as ReactComponent };